/*
 *
 * PProFields
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 29-Jan-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import '../ApmConfigurationModal.scss'
import PortalTextInput from '@nexidigital/portaltextinput'
import { messages } from '../languageModule'
import { useIntl } from 'react-intl'

const PProFields = ({ formik, loading, ...props }) => {
  const intl = useIntl()

  return (
    <div className='ppro_textInput_container'>
      <PortalTextInput
        ariaLabelIcon={intl.formatMessage(messages.warningAriaLabel)} 
        label={intl.formatMessage(messages.pProFieldsContractIdLabel)}
        id='pProContractId'
        type='text'
        onChange={(e) => formik.setFieldValue('contractId', e.target.value)}
        onBlur={() => formik.setFieldTouched('contractId', true)}
        error={!!(formik.touched.contractId && formik.errors.contractId)}
        errorText={formik.errors.contractId}
        value={formik.values.contractId}
        placeholder=' '
        disabled={loading || formik.values.status === 'Disabled'}
        {...props}
      />
      {formik.values.status === 'Enabled' && <p className='ppro_textInput_alert'>{intl.formatMessage(messages.pProFieldsContractIdAlert)}</p>}
    </div>
  )
}

PProFields.propTypes = {
  /** formik object */
  formik: PropTypes.object.isRequired,
  loading: PropTypes.bool
}

PProFields.defaultProps = {
  formik: {}
}

export default PProFields
